<template lang="pug">
div
  section#page-index
    //- 页面标题
    .page-index-title {{title}}
    //- 图集
    div(v-swiper:mySwiper="swiperOpt")
      .swiper-wrapper
        .swiper-slide(v-for="(atlas,i) of sg_commodity_imgs" :key="i")
          img.swiper-img(:src="wrapImageDomain(atlas.image)")
    .dom-sales
      //- 限时优惠文字，用语言包获取
      h2 {{locale.limit_sales}} 
      .sales_wrap
        .sales
          .price
            //- 单位（语言包获取）
            | {{locale.unit}}
            //- 销售价
            ins {{ sale_price }}
        .sales_info
          div
            //- 划线价格
            del {{locale.unit}}{{ market_price }}
          //- 销量
          .sales_num {{ sales_volume }}{{locale.saled}}
    .module_title
      //- 描述
      h1 {{describe}}
    .service-tips
      //- 服务（从语言包获取）
      .service
        span(v-for="(service, si) of locale.service" :key="si") {{service}}
      div(style='color: red; padding-left: 10px; padding-top: 10px;') {{describe}}
    .product_info
      //- 详情文字（语言包获取）
      h2 {{locale.detail}}
      .m-img(v-html="replaceImageDomain(content)")
  section#page-order(:data-error='locale.pleaseChooseError' ref="buynow")
    //- 立即下单文字（语言包获取
    h2 {{locale.buynow}}
    form#order-form(@submit="() => {return submit()}")
      //- 套餐
      #combo-layer
        //- 已选文字（语言包获取）
        h3(style='margin: 10px 0px;') {{locale.choice}}
        #combo_source_data(style='display:none;')
        .combo-list
          //- 循环可选套餐
          div(v-for="pkg in sg_packages" :key="pkg.id")
            label.combo-item(:class="checked == pkg.id ? 'is-active' : ''")
              input(type='radio' :value="pkg.id" v-model="checked")
              | {{pkg.name}}-{{locale.unit}} {{Math.floor(pkg.price)}}
            br
      //- 套餐end
      #product_attr
        //- 循环套餐
        section(v-for="pro in checkedPkg.sg_package_product_relations" style='display: block')
          //- loop product
          .attrs-layer-product-title {{pro.foreign_name}}
          .attrs-layer-groups
            //- 循环属性
            .attrs-layer-group-item(v-for="group of pro.groups" :key="group.id")
              //- 获取外文属性组名称
              .attrs-layer-group-title {{group.sg_attribute_alias_groups[0].name}} 
              .attrs-layer-group-childs
                label.attrs-layer-group-attr-item(v-for="attr of group.attrs" :class="group.checked === attr.sg_sku_attribute.id ? 'is-active' : ''")
                  img(v-if="attr.sg_sku_attribute.image" :src="wrapImageDomain(attr.sg_sku_attribute.image)")
                  input(type='radio' :value="attr.sg_sku_attribute.id" v-model="group.checked")
                  span {{attr.sg_sku_attribute.sg_attribute_aliases[0].name}}
      #order_preview
        h3 {{locale.ordered}}
        .order_preview_body
          table(style="table-layout:fixed;")
            thead
              tr
                th(width='20vw;') {{locale.goodsImage}}
                th(width="50vw;") {{locale.goodsName}}
                th(width='20vw;') {{locale.goodsAttr}}
            tbody
              tr(v-for='(item, index) in checkedPkg.sg_package_product_relations' :key='item.id')
                td
                  img(:src='wrapImageDomain(item.checkedImage)')
                td
                  span.ellipsis(:title="title") {{ title }}
                td {{ item.checkedStr }}
      .order_total
        label {{locale.total}}
        | {{locale.unit}}
        span.js_total {{checkedPkg.price}}
      section.form-layer
        .form-layer-item
          label
            em *
            | {{locale.payment}}
          .form-layer-body
            label.paymethod-item(v-for="type of payment" :key="type" :class="checkedPayment == type ? 'is-active': ''")
              input(:value="type" v-model="checkedPayment" type='radio')
              //- 根据语言选择付款方式
              | {{ locale.paymentType.find((pm) => {return pm.value == type }).name }}
        .form-layer-item
          label
            em *
            | {{locale.clientName}}
          .form-layer-item-body
            input.inputText(v-model="form.name" :placeholder='locale.clientNamePlaceholder' required @invalid="errorHandle")
        .form-layer-item
          label
            em *
            | {{locale.mobile}}
          .form-layer-item-body
            input.inputText(type='text' pattern="[0-9]{8,15}" v-model="form.mobile" maxlength='15', minlength='8', :data-error='locale.mobileError', :placeholder='locale.mobilePlaceholder' required @invalid="errorHandle")
        .form-layer-item
          label
            em *
            | {{locale.area}}
          area-select(:checkedPayment="checkedPayment" :locale="locale" :area="sg_area.name" :area-province="locale.provinceStr" @change="areaChange")
        .form-layer-item
          label
            em *
            | {{locale.address}}
          .form-layer-item-body
            input.inputText(v-model="form.address" :placeholder='locale.addressPlaceholder' :disabled="checkedPayment != 0" required @invalid="errorHandle")
            div.error(v-if="error.address") {{locale.addressError}} 
        .form-layer-item
          label {{locale.email}}
          .form-layer-item-body
            input.inputText(v-model="form.email" :placeholder='locale.emailPlaceholder', maxlength='30', type='email' @invalid="errorHandle")
        .form-layer-item
          label 
            em(v-if="sg_area.name != '台湾'") 
              | *
            |{{locale.postal}}
          .form-layer-item-body
            input.inputText(v-model="form.postal" ref="postal" type="text" pattern="[0-9]{1,20}" :placeholder='locale.postalPlaceholder' :required="sg_area.name != '台湾'" @invalid="errorHandle")
        .form-layer-item
          label {{locale.message}}
          .form-layer-item-body
            textarea(v-model="form.message" rows='1' :placeholder='locale.messagePlaceholder' )
      .submit
        button(@click="submit") {{locale.confirm}}
  .User_notes(style='color:#ccc;line-height: 2em;')
    h2.notes {{locale.note}}
    note(v-if="sg_language" :lang="sg_language.name")
  footer.style1-footer(ref="footerbtn")
    .style1-footer-buynow(v-if="footerShow")
      a(href='#page-order') {{locale.buynow}}

</template>

<script>
// 请求库
import axios from 'axios'

// url处理
import url from 'url'

// 配置
import config from '../../local_env.json'

// 页面组件
// 图集
// import Swiper from '@/components/swiper.vue'
// 地区选择器
import AreaSelect from '@/components/AreaSelect.vue'

// 语言库
import locale from '@/assets/locale'

// 用户须知
import Note from '@/components/note.vue'
import { isNumber } from 'util'



// facebook事件
((f, b, e, v, n, t, s) => {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s)
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')



export default {
  metaInfo () {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          content: this.describe
        }
      ]
    }
  },
  components: {
    // Swiper,
    AreaSelect,
    Note
  },
  data() {
    return {
      footerShow: true,
      // 从接口获取的数据
      title: '标题',
      describe: '描述',
      // 销量
      sales_volume: 999,
      // 销售价
      sale_price: 100,
      // 市场价
      market_price: 200,
      // 图集
      atlas_image: '',
      // 本落地页可选的支付方式
      payment: [],
      // 内容
      content: '内容内容',
      // 套餐列表
      sg_packages: [],
      // 地区
      sg_area: {},

      // 图集
      sg_commodity_imgs: [],

      // 图集配置项
      swiperOpt: {
        autoplay: true,
        delay: 1000
      },

      id_poi_users: 0,

      id_poi_product: 0,

      // 语言
      sg_language: {},

      // 本地使用的临时数据
      // 选中的套餐id
      checked: '',
      // 选中的套餐
      checkedPkg: {},
      // 选中的属性
      checkedPros: [],
      // 选中的付款方式
      checkedPayment: '',
      // 表单错误提示
      error: {
        name: false,
        mobile: false,
        province: false,
        city: false,
        district: false,
        store: false,
        address: false
      },
      // 订单表单数据
      form: {
        name: '',             // 客户姓名
        mobile: '',           // 手机
        province: '',         // 省
        city: '',             // 市
        district: '',         // 区
        address: '',          // 完整地址
        email: '',            // 电邮
        postal: '',           // 邮编
        message: '',          // 留言
        id_poi_area: 0,       // 地区
        domain_name: '',      // 域名
        payment: 1,           // 付款方式
        from: '本地下单',     // 来源渠道，用referrer获取，如果没有获取到对应值，就用本地下单
        id_poi_users: '',     // 优化师id
        id_poi_product: 1,    //产品id
        selected_package: {   // 套餐信息
          id: 1,              // 套餐id
          products: [         // 套餐内选择的产品、属性
            {
              id: 1,          // 套餐内产品id（非产品库id，是关联id）
              attrs: [        // 选择的属性id

              ]
            }
          ]
        }
      },
      locale: {}              // 语言包
    }
  },
  watch: {
    /**
     * 套餐变更之后的操作
     */
    checked(checkedId) {
      // 将选中套餐赋值到checkedPkg
      this.checkedPkg = this.sg_packages.find((pkg) => {
        return pkg.id == checkedId
      })
      // 将选项赋值到checkedAttributes
      this.checkedPros = this.checkedPkg.sg_package_product_relations.map((pro) => {
        pro.groups.map((group) => {
          group.checked = group.attrs[0].id_poi_sku_attribute
        })
        return pro
      })
      console.log(this.checkedPros)
    },
    /**
     * 付款方式改变时，清空地址
     */
    checkedPayment() {
      this.form.address = ''
    },
    /**
     * 已选属性发生变化时，计算选中属性的字符串，更换已选列表的图片等
     */
    checkedPros: {
      deep: true,
      handler(newPros) {
        // console.log('checked attr change!', newPros)
        newPros.map((pro) => {
          let checkedImage = pro.sg_product.image
          let attrsStr = pro.groups.reduce((result, group) => {
            let checkedAttr = group.attrs.find((attr) => {
              return attr.id_poi_sku_attribute === group.checked
            }).sg_sku_attribute
            if (checkedAttr.image) {
              checkedImage = checkedAttr.image
            }
            return result + checkedAttr.sg_attribute_aliases[0].name
          }, '')
          pro.checkedImage = checkedImage
          pro.checkedStr = attrsStr
          return pro
        })
      }
    }
  },
  methods: {
    /**
     * 错误处理函数
     */
    errorHandle(e) {
      // console.log(e.target.validity, e.target, e.target == this.$refs.postal)
      // 处理必填项
      if (e.target.validity.valueMissing) {
        e.target.setCustomValidity(this.locale.missingValue)
        return
      } else {
        // e.target.setCustomValidity('')
      }

      // 处理长度错误
      if (e.target.validity.tooShort || e.target.validity.tooLong) {
        e.target.setCustomValidity(this.locale.lengthError)
        return
      }else {
        e.target.setCustomValidity('')
      }

      // 处理格式错误
      if (e.target.validity.typeMismatch || e.target.validity.patternMismatch) {
        // 如果是邮编的格式错误
        if (e.target == this.$refs.postal) {
          // 使用数字不匹配的错误提示
          e.target.setCustomValidity(this.locale.numberMismatch)
        } else {
          // 其他使用通用的格式不匹配提示
          e.target.setCustomValidity(this.locale.mismatch)
        }
        return
      }else {
        e.target.setCustomValidity('')
      }
    },
    // 给url添加oss域名前缀
    wrapImageDomain(url) {
      return config.imageDomain + url
    },
    // 替换富文本中所有的oss图片地址，加上oss域名前缀
    replaceImageDomain(content) {
      if(!content) return
      return content.replace(/"\.{0,2}\/files/g, `"${config.imageDomain}files`)
    },
    // 区域值发生变化的处理函数
    areaChange(value) {
      let {store, province, city, district} = value
      if (store) {
        this.form.address = `${store.address},店名：${store.name},店號：${store.id},電話：${store.tel}`
        this.form.province = province
        this.form.city = city
        this.form.district = district

      } else {
        this.form.province = province
        this.form.city = city
        this.form.district = district
        this.form.address = ''
      }
    },
    // 表单提交
    async submit(e, a) {
      console.log(e, a)
      // 禁用按钮，避免重复点击
      e.target.disabled = true
      
      if (!this.form.name) {
        console.log('姓名')
        e.target.disabled = false
        return
      }  
      if (!this.form.mobile || this.form.mobile.length < 8 || this.form.mobile.length > 15) {
        console.log('手机长度')
        e.target.disabled = false
        return
      }

      console.log('is nan',this.form.mobile.match(/[^\d]/g))
      if (this.form.mobile.length > 0 && this.form.mobile.match(/[^\d]/g) != null) {
        console.log('手机格式错误')
        e.target.disabled = false
        return false
      }

      // if (!this.form.province) {
      //   console.log('省')
      //   return false
      // }

      if (this.sg_area.name != '台湾') {
        if (!this.form.postal) {
          console.log('邮编')
          e.target.disabled = false
          return false
        }

        if (this.form.postal.length > 0 && this.form.postal.match(/[^\d]/g) != null) {
          e.target.disabled = false
          return false
        }

      } else {
        
        if (!this.form.city) 
        {
          console.log('城市')
          e.target.disabled = false

          return false
        } 
        if (!this.form.district) {
          console.log('行政区')
          e.target.disabled = false

          return false
        }
      }

      if (this.form.email && !this.form.email.includes('@')) {
        e.target.disabled = false
        return
      }
      
      if (!this.form.address) {
        e.target.disabled = false
        return
      } 

      if (this.locale.provinceStr) {
        this.form.province = this.locale.provinceStr
      }
      this.form.id_poi_area = this.sg_area.id
      this.form.id_poi_users = this.id_poi_users
      this.form.id_poi_product = this.id_poi_product
      this.form.domain_name = this.domain_name
      this.form.payment = parseInt(this.checkedPayment) + 1 // + 1 做容错，原来是0，1，2
      this.form.selected_package.id = this.checkedPkg.id    // 选中的套餐id
      // 处理渠道来源
      let ref = document.referrer
      let urlRes = url.parse(ref)
      // 包含facebook
      if (urlRes.hostname) {
        if (urlRes.hostname.includes('facebook')) {
          this.form.from = 'fb下单'
        }
      }
      

      // this.form.from = document.referrer                    // 记录来源
      this.form.selected_package.products = this.checkedPros.map((pro) => {
        let attrs = pro.groups.map((group) => {
          return group.checked
        })
        return {
          id: pro.id,
          attrs
        }
      })

      this.form.package_name = this.checkedPkg.name
      this.form.package_image = this.checkedPkg.image


      let data = {...this.form}
      e.preventDefault()

      try {
        let res =  await axios.post(`${config.api}order/post`, 
          data,
          {headers: config.headers}
        )
        // alert('下单成功')                 // 下单成功的提示要改成什么
        console.log(res.data)
        this.$router.push({name: 'result', query: {
          order_no: res.data.data.order_no,
          lang: this.sg_language.id
        }})
      } catch (e) {
        if (e.response.data.msg) {
          if (this.locale[e.response.data.msg]) {
            alert(this.locale[e.response.data.msg])
          } else {
            alert(e.response.data.msg)
          }
        } else {
          alert('下单出现问题，请联系客服') // 失败的提示
        }
        e.target.disabled = false
      }
      e.target.disabled = false

      return false
    },
  },
  async mounted() {
    // console.log(url.parse(document.referrer))

    // 定时判断当前滚动的位置，计算立即下单是否需要隐藏
    setInterval(() => {
      this.$nextTick(() => {
        let dom = this.$refs.footerbtn    // 立即下单按钮的dom元素
        let dom1 = this.$refs.buynow      // 立即下单卡片的dom元素
        if (dom && dom1) {
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          if (scrollTop + dom.offsetTop - dom1.offsetTop < 0) {
            this.footerShow = true
          } else {
            this.footerShow = false
          }
        }
      })
    }, 200)

    // 获取站点id
    let id = this.$route.params.id
    let params = { id }
    // 请求电商页数据
    let res = await axios.get(`${config.api}commodity/get`, {
      params,
      headers: config.headers
    })
    let data = res.data.data

    console.log('pixel', data.pixel)
    
    /* eslint-disable */
    fbq('init', data.pixel)
    fbq('track', "PageView")
    fbq('track', 'ViewContent')
    /* eslint-disable */

    // 语言选项
    // console.log('语言', data.sg_language)
    data.locale = locale(data.sg_area.name, data.sg_language.name)

    // 将付款方式从字符串解构为json数组
    data.payment = JSON.parse(data.payment)

    // 设置一个支付方式的默认值
    this.checkedPayment = data.payment[0]

    // 将套餐内数据进行组织
    data.sg_packages.map((pkg) => {
      pkg.sg_package_product_relations.map((pro) => {
        // 属性组去重获取
        let groups = pro.sg_package_product_attribute_relations.reduce((result, attrs) => {
          let groupInResult = result.find((r) => {
            return r.id === attrs.sg_sku_attribute.sg_sku_attribute_group.id
          })
          if (!groupInResult) {
            result.push(attrs.sg_sku_attribute.sg_sku_attribute_group)
          }
          return result

        }, [])
        // 设置属性组的选中状态初值，将属性放到属性组中
        groups.map((group) => {
          group.checked = false
          group.attrs = pro.sg_package_product_attribute_relations.filter((attr) => {
            // console.log('attr', attr)
            return attr.sg_sku_attribute.id_poi_sku_attribute_group == group.id
          })
        })
        // 将重组好的属性组重新赋值给套餐内关联产品
        pro.groups = groups
        return pro
      })
      return pkg
    })

    // 设置套餐选中默认值
    if (data.sg_packages.length > 0) {
      this.checked = data.sg_packages[0].id
    }

    console.log(data.sg_commodity_imgs)

    // 将数据设置到data中
    for(let k in data) {
      this[k] = data[k]
    }
  }
}
</script>

<style scoped>
@import '../style/index/reset.css';
@import '../style/index/index.css';

html {
  background-color: red !important;
}
.ellipsis {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.swiper-img {
  width:100%;
  object-fit: contain;
}
</style>
